import React from "react";
import errorImg from "../assets/errorImg.jpg";
import OrderBtn from "../utils/OrderBtn";
import config from "../config";

const ErrorPage = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ background: `var(--primary-bg)` }}
    >
      <div className="error_container my-5">
        <img
          src={errorImg}
          alt="error page"
          className="image-fluid w-50 my-5"
        ></img>
        <OrderBtn text="Back To Home" url="/" />
      </div>
    </div>
  );
};

export default ErrorPage;
